import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, ButtonGroup, rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { isPremiumTier, Tier } from 'features/premium/entities';
import { isUnlocked } from 'features/premium/isUnlocked';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { benefits } from 'features/premium/benefits';
import { useAppSelector } from 'store/hooks';
import { selectUserTier } from 'features/premium/selectors/tier';
import { UpSellButtons, UpSellCard, } from 'features/premium/components/PremiumFeatureMicroModalContent';
import { selectShouldShowMicroModal } from 'features/premium/selectors';
const ForceSyncUpgradeModal = () => {
    const navigation = useMainStackNavigation();
    const userTier = useAppSelector(selectUserTier);
    const onUpgrade = () => {
        const tier = benefits.forceSync.minTier;
        Modal.hide(() => {
            navigation.navigateDeprecated('EmmaProModal', {
                tier: isPremiumTier(tier) ? tier : undefined,
                benefitId: 'forceSync',
            });
        });
    };
    const onPressMaybeLater = () => {
        Modal.hide();
    };
    // Ab test
    const showMicroModal = useAppSelector(selectShouldShowMicroModal);
    const subCopy = useMemo(() => {
        const originalCopy = (<Text TextThin-14 Secondary style={styles.description} centered>
        Emma updates {isUnlocked(userTier, Tier.plus) ? '4x ' : ''}daily with
        the information from your bank. With Pro or Ultimate, you can sync
        anytime.
        {!isUnlocked(userTier, Tier.plus) &&
                ' For more automatic daily syncs, upgrade to any plan.'}
      </Text>);
        if (showMicroModal) {
            return (<Text TextThin-14 Secondary style={styles.description} centered>
          Emma automatically updates your bank data{' '}
          {isUnlocked(userTier, Tier.plus)
                    ? 'up to 4 times a day. '
                    : 'daily. '}
          With Emma Pro or Ultimate, you can sync your accounts anytime, on
          demand.
        </Text>);
        }
        return originalCopy;
    }, [userTier, showMicroModal]);
    return (<View>
      {subCopy}
      {showMicroModal === 'v2' ? (<>
          <UpSellCard />
          <UpSellButtons onCancel={onPressMaybeLater} onContinue={onUpgrade}/>
        </>) : (<ButtonGroup margins={false}>
          <Button brandReversed title={showMicroModal ? 'No, thanks' : 'Maybe later'} onPress={onPressMaybeLater} testID="maybeLaterButton"/>
          <Button brand title="Continue" onPress={onUpgrade} testID="viewUpgradeOptionsButton"/>
        </ButtonGroup>)}
    </View>);
};
const styles = StyleSheet.create({
    description: {
        marginTop: rem(8),
        marginBottom: rem(16),
    },
});
export default ForceSyncUpgradeModal;
